import { useState } from "react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { useI18n } from "@/i18n/I18nProvider";
import { useAuth } from "@/context/AuthContext";
import { api, errorKey } from "@/lib/api";
import { SaveButton } from "@/pages/admin/settings/CompanyForm";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordForm = ({ bare = false, temporary = false, onDone }) => {
  const { t } = useI18n();
  const { updateUser } = useAuth();
  const [f, setF] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.current) return setError("validation.required");
    if (f.next.length < 8) return setError("validation.minPassword");
    if (f.next !== f.confirm) return setError("validation.mismatch");
    setBusy(true);
    setError("");
    try {
      const r = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setF(EMPTY);
      updateUser(r.data.user);
      toast.success(t("settings.passwordChanged"));
      onDone?.(r.data.user);
    } catch (err) {
      setError(errorKey(err));
    } finally {
      setBusy(false);
    }
  };

  const fields = [["current", temporary ? "temporaryPassword" : "currentPassword", "current-password"], ["next", "newPassword", "new-password"], ["confirm", "confirmPassword", "new-password"]];
  const box = bare ? "" : "max-w-lg rounded-xl border border-[#E5E7EB] bg-white p-4 sm:p-6";
  return (
    <form onSubmit={submit} className={box} data-testid="change-password-form" noValidate>
      {!bare && <h2 className="mb-4 font-display text-lg font-bold text-[#000B45]">{t("settings.changePassword")}</h2>}
      <div className="space-y-4">
        {fields.map(([k, label, ac]) => (
          <div key={k} className="space-y-1.5">
            <Label htmlFor={`pw-${k}`}>{t(`settings.${label}`)}</Label>
            <PasswordInput id={`pw-${k}`} autoComplete={ac} testId={`password-${k}-input`} value={f[k]}
              onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-12 bg-white text-base" />
          </div>
        ))}
      </div>
      {error && <p data-testid="change-password-error" className="mt-4 text-sm font-medium text-red-600">{t(error)}</p>}
      <div className="mt-6 flex justify-end"><SaveButton busy={busy} testId="change-password-submit" /></div>
    </form>
  );
};
